import { useTranslation } from 'react-i18next';

import { Toast } from '../../components/Toast';
import type { NotificationState } from './useNavbar';

// Mesmo `timeOut` default do toastr legado.
const NOTIFICATION_DURATION_MS = 5000;

export interface NavbarNotificationProps {
  notification: NotificationState | null;
  onDismiss: () => void;
}

/**
 * Notificação da navbar com o título e a duração do toastr legado. A tradução acontece aqui, no
 * render, para o aviso de troca de idioma já sair no idioma novo.
 */
export function NavbarNotification({
  notification,
  onDismiss,
}: NavbarNotificationProps): JSX.Element | null {
  const { t } = useTranslation();

  // Só montado com notificação: o `Toast` exige mensagem, e assim o aviso some na hora ao fechar,
  // sem um `Alert` vazio durante a animação de saída.
  if (notification === null) {
    return null;
  }

  return (
    <Toast
      open
      title={t(`navbar.notification.title.${notification.severity}`)}
      message={t(notification.messageKey)}
      severity={notification.severity}
      onClose={onDismiss}
      autoHideDuration={NOTIFICATION_DURATION_MS}
    />
  );
}
